import { scroller } from 'react-scroll';

/**
 * Scrolls to a specific Element by name
 * @param className {String}
 * @param duration {number}
 * @param delay {number}
 */
export const scrollTo = (className: string, duration = 500, delay = 0) => {
  scroller.scrollTo(className, {
    duration: duration,
    delay: delay,
    smooth: 'easeInOutQuint',
    offset: -110,
  });
};
